export default "/kiban/_next/static/images/bottom_blue-b6115e8c752d9c7b90184571062aac07.png";